<template>
<div class="slide slide04">
    <h3 class="title">
        <div class="mo">화재보험 장기보험 캠페인</div>
        Strategy &amp; Result
    </h3>
    <span class="text">
        고객 DB확장 및 신규매체 발굴을 위해 DA / RT / Native / Video 영역의 성과 확대 및 최적화 진행 <br>
        운영초기 고객 DB 비중 4% → 40%의 주력채널로 성장하며 필요 고객 DB 수급 성공
    </span>
    <div class="graphWrap">
        <div class="graph g1">
            <img src="@/assets/images/graphImg04.png" alt="OOO화재 Native 채널 운영 사례">
        </div>
        <div class="graph g2">
            <img src="@/assets/images/graphImg05.png" alt="OOO화재 DA 채널 운영 사례">
        </div>
    </div>

    <div class="btnsWrap">
		<a herf="javascript:;" @click="fnSlickNext" class="slideNextBtn" v-if="!$device.windows">다음 페이지</a>
	</div>
</div>
</template>
<script>
export default {
    methods:{
		fnPopClose(){
			this.$emit('popClose' , event)
		},
		fnSlickNext(){
			this.$emit('slick_next' , event)
		}
	}
}
</script>